import { mapGetters, mapActions } from 'vuex'
import SheetWrapper from '@/components/SheetWrapper/index'

export default {
  name: 'league-table',
  components: {
    SheetWrapper
  },
  data: () => ({
    teamsArr: null,
    hasWon: position => position < 5,
    hasLost: position => position > 17,
    labels: ['P', 'W', 'D', 'L', 'GD', 'Pts'],
    sampleLogo: require('@/assets/default-avatar.svg')
  }),

  computed: {
    ...mapGetters('league', {
      standingsResponse: 'STANDINGS'
    })
  },
  methods: {
    ...mapActions('league', {
      fetchStandingAction: 'FETCH_STANDINGS'
    })
  },
  activated() {
    this.fetchStandingAction().then(() => {
      this.teamsArr = this.standingsResponse.data
    })
  }
}
